import * as angular from "angular";
import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import "./vehicleInputTypeManager.scss";
import { TranslationService } from "@services/translation.service";
import { InputTypeService } from "@services/inputType.service";
import { IInputType } from "@interfaces/IInputType";
import { InputStateDescription } from "@interfaces/IVehicleInput";

class VehicleInputManagerController implements angular.IComponentController {

    inputTypeRows: IVeriListRow<IInputType>[] = [];

    inputTypes: IInputType[];

    selectedType: IInputType;

    stateDescriptions: number[];

    errorMessage: string;

    checkboxTicked: boolean;
    loading: boolean;

    static $inject = ["translationService", "inputTypeService"];

    constructor(
        private readonly translationService: TranslationService,
        private readonly inputTypeService: InputTypeService
    ) {}

    $onInit() {
        this.loadInputTypes();
        this.getStateDescriptions();
    }

    addNewInputType() {
        this.errorMessage = '';

        const newInputType: Partial<IInputType> = {
            Name: this.translationService.t("vehicleInputManager.newInputType"),
        };

        this.setSelectedType(newInputType as IInputType);
    }

    isNameDuplicate() {
        this.errorMessage = "";

        const isDuplicate = this.inputTypes
            .filter((type) => type.Id !== this.selectedType.Id)
            .some((type) => type.Name.toLowerCase() === this.selectedType.Name?.trim().toLowerCase());

        if (isDuplicate) {
            this.errorMessage = this.translationService.t("vehicleInputManager.nameIsTaken");
        }
    }

    isDefaultType(): boolean {
        return !this.selectedType.AccountId && this.selectedType.Id >= 0;
    }



    deleteInputType() {
        this.loading = true;

        this.inputTypeService.deleteInputTypes(this.selectedType).finally(() => {
            this.loadInputTypes(true).then(() => {
                this.selectedType = null;
                this.loading = false;
            });
        });
    }

    saveInputType() {
        if (!this.selectedType) {
            return;
        }

        this.loading = true;

        this.inputTypeService
            .addOrUpdateInputTypes(this.selectedType)
            .then(() => {
                this.loadInputTypes(true).then(() => {
                    this.selectedType = null;
                    this.loading = false;
                });
            });
    }

    setSelectedType(inputType: IInputType) {
        if (this.selectedType && this.selectedType.Id === inputType.Id) {
            this.selectedType = null;
            return;
        }

        this.errorMessage = '';

        this.selectedType = angular.copy(inputType);
        this.checkboxTicked = false;
    }

    // ---------

    private loadInputTypes(invalidateCache = false):  angular.IPromise<any> {
        this.loading = true;

        return this.inputTypeService.getInputTypes(invalidateCache)
            .then(inputTypes => {

                this.inputTypes = inputTypes;
                this.createInputTypeRows(this.inputTypes);
                this.loading = false;
            });
    }

    private getStateDescriptions(): void {
        this.inputTypeService.getStateDescriptions().then(stateDescriptions => {
            this.stateDescriptions = stateDescriptions;
        })
    }

    private createInputTypeRows(inputTypes: IInputType[]) {
        this.inputTypeRows = [];

        inputTypes.forEach(inputType => {

            const contents = `
                <div> ${inputType.Name} &nbsp;
                    <input-state-description description-id="${inputType.InputStateDescription}"></input-state-description>
                </div>
                <i ng-if="${!inputType.AccountId}"  class="material-icons">lock</i>
            `;

            this.inputTypeRows.push({
                id: inputType.Id,
                contents,
                data: inputType,
                sortData: inputType.Name,
                className: 'default-input-type'
            });
        });
    }
}

export class VehicleInputTypeManagerComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {};

        this.controller = VehicleInputManagerController;
        this.template = require("./vehicleInputTypeManager.html");
    }
}
